import type { Entity } from 'cesium';
import { defined } from 'cesium';
import { derived, writable } from 'svelte/store';
import { getEntityPropertyBag } from './map-utils';

const selectedMapEntity = writable<Entity | undefined>(undefined);

const selectedMapEntityPropertyBag = derived(selectedMapEntity, ($selectedMapEntity) => {
	if (defined($selectedMapEntity) && $selectedMapEntity) {
		return getEntityPropertyBag($selectedMapEntity);
	} else {
		return undefined;
	}
});

export { selectedMapEntity, selectedMapEntityPropertyBag };
